import api from 'api'

const basePath = (blockSurveyId: number) =>
  `administration/block_surveys/${blockSurveyId}`

/** Copies a survey of the bank into a course survey without questions. */
export const applySurveyTemplate = (
  blockSurveyId: number,
  surveyTemplateId: number
) =>
  api.post(`${basePath(blockSurveyId)}/apply_template`, {
    surveyTemplateId,
  })

/** Creates a new survey of the bank from a course survey. */
export const saveSurveyToTemplate = (
  blockSurveyId: number,
  surveyTemplate: { name: string; description: string }
) =>
  api.post(`${basePath(blockSurveyId)}/save_to_template`, {
    surveyTemplate,
  })
